export const toRem = (value: number) => {
	return `${value / 16}rem`
}
